import ErrorIcon from "@mui/icons-material/Error";

export const ErrorMessage = ({ message }: { message?: string }) => {
  return message ? (
    <>
      <ErrorIcon />
      {message}
    </>
  ) : (
    <></>
  );
};
